export default __webpack_public_path__ + "static/media/Photo_perfil.33ef8090.jpg";